import React from 'react';

const InsuranceDashboard = () => (
  <div className="p-8 text-center">
    <h2 className="text-2xl font-bold">Welcome, Insurance Provider</h2>
    <p className="text-gray-600 mt-4">Access client profiles and claims reports.</p>
  </div>
);

export default InsuranceDashboard;
